export const provisioningZhCN = {
  nav: { provisioning: '自动装机' },
  provisioning: {
    batchItems: '批次项目',
    server: '服务器',
    title: 'Provisioning 自动装机',
    description: '管理 OS 镜像、PXE Profile、装机网络、安装任务和安全 dry-run 结果',
    safetyNotice: '当前阶段仅开放 dry-run 和配置渲染核验，不启用 DHCP/TFTP/iPXE，不重载服务，不擦盘。',
    simpleWorkbenchKicker: 'INSTALL WORKBENCH',
    simpleWorkbenchTitle: '简单装机工作台',
    simpleWorkbenchDescription: '面向日常运维的简化流程：先把服务器录入库存并核对 MAC，再选择系统和目标网卡，最后只做 dry-run / PXE 渲染检查。真实 DHCP/PXE 执行仍然关闭。',
    simpleStepInventory: '库存确认',
    simpleStepInventoryDesc: '确认服务器 SN、BMC、网卡 MAC 和机房机柜位置。',
    simpleStepSelectOS: '选择系统',
    simpleStepSelectOSDesc: '选择 OS 镜像、PXE Profile 和装机网络。',
    simpleStepMacCheck: 'MAC 对比',
    simpleStepMacCheckDesc: '目标 MAC 必须来自库存/Discovery；不一致就不允许安装。',
    simpleStepDryRun: '安全检查',
    simpleStepDryRunDesc: '先生成 manifest 并检查 Agent、VLAN、DHCP 窗口和白名单。',
    simpleCreateSingleInstall: '创建单台装机任务',
    simpleCreateBatchInstall: '创建批量装机计划',
    simpleNoRealExecution: '当前不会启动真实 DHCP/TFTP/iPXE，也不会重启或擦盘。',
    simpleReadyServers: '待确认服务器',
    simplePxeNics: 'PXE 可用网卡',
    simpleOnlineAgents: '在线 Agent',
    simpleImagesProfiles: '镜像 / Profile',
    simpleSafetyTitle: '装机安全规则',
    simpleRuleMacMatch: '安装前必须二次核对目标 MAC，和库存/Discovery 不一致就终止。',
    simpleRuleOneTimeBoot: '不是默认网卡启动的服务器，后续真实执行必须通过 BMC/IPMI 设置一次性 PXE/NIC 启动再重启。',
    simpleRuleFailStop: '安装失败、超时或 Agent 断联时任务必须终止，不能反复重试危险动作。',
    simpleRuleTemporaryDHCP: 'DHCP/PXE 只能在安装窗口临时开启，成功、失败或超时后必须自动关闭并清理白名单。',
    installSafetyStatusTitle: '装机安全状态',
    installSafetyStatusDescription: '给运维看的安全状态：当前系统是否会真的开 DHCP/PXE、重启服务器或执行危险任务。',
    installSafetyStatusMessage: '安全状态已同步，真实装机执行仍保持锁定。',
    installSafetyLocked: '安全锁定',
    installSafetyNeedsReview: '需要检查',
    installSafetySynced: '状态已同步',
    installSafetyFallback: '状态待确认',
    plainMacCheck: 'MAC 校验',
    plainMacCheckDesc: '装机任务必须使用库存/Discovery 里的目标 MAC。',
    plainPxeExecution: '真实 PXE 执行',
    plainPxeExecutionDesc: '当前不允许真正启动 DHCP/TFTP/iPXE。',
    plainDhcpWindow: 'DHCP/PXE 临时服务',
    plainDhcpWindowDesc: '没有临时装机窗口时应保持关闭。',
    plainDangerTasks: '危险任务',
    plainDangerTasksDesc: '真实改网络、清理网络或执行中的危险任务数量。',
    enabled: '开启',
    disabled: '关闭',
    advancedDiagnostics: '展开高级诊断',
    advancedDiagnosticsDesc: '以下是开发和排障使用的底层安全计数，普通运维日常不用看。',
    installableInventoryTitle: '库存可装机服务器',
    installableInventoryDescription: '从库存/自动发现结果里汇总可装机服务器，重点核对 SN、BMC、目标 MAC 和 Agent 在线状态。',
    servers: '个装机目标',
    serverIdentity: '服务器',
    nicMac: '网卡 / MAC',
    macVerified: 'MAC 已核对',
    verified: '已核对',
    pendingVerify: '待核对',
    latestInstall: '最近装机',
    installAllowed: '允许装机',
    startInstall: '发起装机',
    manualBootRequired: '需人工确认启动网卡',
    yes: '是',
    no: '否',
    inventoryBlockedNoMac: '缺少目标 MAC',
    inventoryBlockedAgentOffline: 'Agent 不在线',
    inventoryBlockedMissingConfig: '缺少 OS 镜像或 PXE Profile',
    inventoryBootOverrideDefaultReason: '该网卡未标记为 PXE 默认可用，后续真实执行前需通过 BMC/IPMI 设置一次性 PXE/NIC 启动',
    osImages: 'OS 镜像',
    pxeProfiles: 'PXE Profile',
    networks: '装机网络',
    installBatches: '安装批次',
    installTasks: '安装任务',
    logs: '安装日志',
    checks: '网络检查',
    allowlist: 'MAC 白名单',
    createImage: '新建镜像',
    createProfile: '新建 Profile',
    createNetwork: '新建装机网络',
    configureNetwork: '配置网络',
    createBatch: '新建安装批次',
    createTask: '新建安装任务',
    dryRunNetwork: '网络 dry-run',
    installDryRun: '安装 dry-run',
    pxeRenderDryRun: 'PXE 渲染 dry-run',
    createBootPlan: '生成启动计划',
    bootPlanLatest: '最近生成的启动计划',
    bootPlanReadonlyNotice: '只生成一次性 PXE 启动计划，不执行 IPMI/Redfish，不重启服务器。',
    bootPlanOneTimeBoot: '一次性启动',
    bootPlanExecution: '真实执行',
    bootPlanNoExecution: '当前只是计划，未执行 BMC 命令、未重启、未启动 DHCP/PXE。',
    bootPlanReady: '启动计划已生成',
    bootPlanCreated: '启动计划已生成，未执行真实操作',
    bootPlanTooltip: '生成 BMC 一次性 PXE 启动 dry-run 计划',
    bootPlanBlockedStatus: '只有未开始执行的装机任务才能生成启动计划',
    bootPlanBlockedNoNic: '缺少 Discovery 网卡，不能核对 MAC',
    bootPlanBlockedNoBmc: '缺少 BMC IP，不能生成启动计划',
    installFlowTitle: '装机流程总览',
    installFlowDescription: '用运维能看懂的方式展示每台机器当前走到哪一步：库存、MAC、启动计划、真实执行。',
    flowInventory: '库存录入',
    flowInventoryDone: '已关联库存 / Discovery',
    flowInventoryMissing: '未关联库存，先录入服务器',
    flowMacCheck: 'MAC 核对',
    flowMacDone: '目标 MAC 已绑定',
    flowMacMissing: '缺少目标 MAC 或网卡',
    flowBootPlan: '启动计划',
    flowBootPlanDone: '一次性 PXE 启动计划已生成',
    flowBootPlanReady: '可生成计划，尚未真实执行',
    flowRealInstall: '真实装机',
    flowRealInstallLocked: '当前锁定，未启动 DHCP/PXE/IPMI',
    tasks: '个任务',
    taskWizardSafetyNotice: '当前只是创建装机任务和 MAC 白名单记录，不会启动 DHCP/TFTP/iPXE，不会重启服务器，不会擦盘。',
    taskWizardStepServer: '选服务器 / MAC',
    taskWizardStepOS: '选系统镜像',
    taskWizardStepConfirm: '确认 dry-run',
    taskWizardServerTitle: '第一步：选择要装机的服务器',
    taskWizardServerDesc: '从库存 / Discovery 里选择网卡，系统会自动带出 MAC 和 BMC IP。MAC 不一致就不能继续。',
    taskWizardOSTitle: '第二步：选择系统和装机配置',
    taskWizardOSDesc: '选择 OS 镜像、PXE Profile 和装机网络。当前仍然只创建任务，不启动真实 PXE 服务。',
    taskWizardConfirmTitle: '第三步：确认后创建任务',
    taskWizardConfirmDesc: '确认目标 MAC、BMC、系统镜像和 Agent。保存后进入待执行 / dry-run 阶段。',
    taskWizardConfirmSafety: '保存后不会真实装机。后续还需要生成启动计划和 PXE dry-run，确认无误后才能进入真实执行设计。',
    taskWizardMissingRequired: '请先补全当前步骤的必填信息',
    previousStep: '上一步',
    nextStep: '下一步',
    batchDryRun: '批次 dry-run',
    batchDryRunConfirm: '确认排队批次 PXE render dry-run？此操作仅生成 staging manifest，不启动 DHCP/TFTP/iPXE，不擦盘。',
    viewBatchDetail: '查看详情',
    batchDetail: '批次详情',
    batchSummary: '批次概要',
    batchDetailReadonlyNotice: '只读审计视图：不会启动 DHCP/TFTP/iPXE，不会擦盘。',
    latestDryRun: '最近 dry-run',
    agentTaskId: 'Agent Task ID',
    manifestPath: 'Manifest Path',
    renderedFileCount: '渲染文件数',
    renderedFiles: '渲染文件',
    safetyFlags: '安全标志',
    noLatestDryRun: '当前批次还没有关联的 Agent dry-run 结果。',
    activationPreflight: '激活预检',
    activationPreflightNotice: '只做开闸条件检查，不启动 DHCP/TFTP/iPXE。',
    activationPreflightPassed: '激活预检通过',
    activationPreflightFailed: '激活预检未通过',
    activationPreflightMissingHash: '缺少 Manifest Hash，不能预检',
    hostBindPreflight: 'Host Bind 预检',
    hostBindPreflightNotice: '只检查 Agent 网卡 / VLAN / bind_ip / lease 条件，不执行真实网络变更，不启动 DHCP/TFTP/iPXE。',
    hostBindPreflightSummary: 'Host Bind 预检概要',
    hostBindPreflightPassed: 'Host Bind 预检通过',
    hostBindPreflightFailed: 'Host Bind 预检未通过',
    createHostBindDryRunLease: '创建 dry-run lease',
    hostBindDryRunLease: 'Host Bind dry-run lease',
    hostBindDryRunLeaseNotice: '只创建审计/协作 lease，不创建 Agent task，不修改网卡，不启动 DHCP/TFTP/iPXE。',
    hostBindDryRunLeaseConfirm: '确认创建 Host Bind dry-run lease？此操作只写入审计 lease，不会创建 Agent task，不会修改远端网卡或启动 DHCP/TFTP/iPXE。',
    hostBindDryRunLeaseCreated: 'Host Bind dry-run lease 已创建',
    hostBindLeases: 'Host Bind Leases',
    hostBindLeaseReadonlyNotice: '只读历史视图，不提供 apply/cleanup 操作。',
    hostBindGuardTitle: 'Host Bind 安全护栏',
    hostBindGuardDescription: 'Contract-only / locked：Master 和 UI 不开放 apply/cleanup，不创建 Agent task，不修改网卡，不启动 DHCP/TFTP/iPXE。',
    contractOnlyLocked: 'CONTRACT-ONLY LOCKED',
    visibleActiveBindLeases: '当前可见活跃 lease',
    visibleApplyCleanupTaskRefs: '当前可见 apply/cleanup task 引用',
    backendAuthoritative: '后端权威计数',
    visibleFallback: '可见数据降级',
    guardStatusLoadFailed: 'Guard 状态加载失败',
    authoritativeActiveBindLeases: 'DB 活跃 bind lease',
    authoritativeDryRunBindLeases: 'DB dry-run bind lease',
    authoritativeApplyCleanupTaskRefs: 'DB apply/cleanup task 引用',
    authoritativeApplyCleanupAgentTasks: 'DB apply/cleanup AgentTask',
    pendingRunningApplyCleanupTasks: 'Pending / Running apply-cleanup 任务',
    applyCleanupApiLocked: 'Apply/Cleanup API 锁定',
    agentTaskCreationEnabled: 'AgentTask 创建开关',
    uiApplyCleanupActions: 'UI apply/cleanup 操作',
    supportedBindMethods: '支持的 bind method',
    applyCleanupTaskTypes: 'Apply/Cleanup task 类型',
    applyCleanupTaskRefs: 'Apply/Cleanup task 引用',
    notExposed: '未开放',
    reviewRequired: '需要复核',
    none: '无',
    leaseNetworkFilter: '按装机网络过滤',
    leaseStatusFilter: '按 lease 状态过滤',
    leaseActivity: 'Lease 活跃性',
    activeLease: '活跃',
    inactiveLease: '非活跃/过期',
    applyStrategy: 'Apply Strategy',
    preflightCheckCount: '预检项数量',
    activationLocked: 'Activation Locked',
    bindApplyEnabled: 'Bind Apply Enabled',
    bindMethod: 'Bind Method',
    check: '检查项',
    installTaskId: '安装任务 ID',
    operatorTaskListTitle: '装机任务单',
    operatorTaskListDesc: '按服务器视角查看：目标机器、MAC、系统、状态和日志。内部 ID 默认收起，排障时再展开。',
    taskTotal: '全部',
    taskActive: '进行中',
    taskSucceeded: '成功',
    taskFailed: '异常',
    taskTechnicalDetail: '技术详情',
    unknownServer: '未关联库存服务器',
    switchPortUnknown: '交换机端口未录入',
    osAndTemplate: '系统 / 模板',
    createdAt: '创建时间',
    errorMessage: '错误信息',
    deviceId: '服务器 ID',
    taskFocusTitle: '已定位到这台服务器的装机任务',
    taskFocusDesc: '当前只显示从库存服务器详情跳转过来的相关装机任务。',
    showAllTasks: '显示全部任务',
    taskDetail: '装机任务详情',
    taskDetailReadonlyNotice: '这里集中查看装机任务资料、白名单、启动计划和日志；不会启动 DHCP/PXE/IPMI，不会重启或擦盘。',
    taskDetailServer: '目标服务器',
    taskDetailInstallInfo: '装机信息',
    taskDetailNetworkInfo: '网络信息',
    taskDetailFlow: '任务流程',
    taskDetailBootPlan: '启动计划',
    taskDetailIds: '关联 ID',
    switchPort: '交换机端口',
    noBootPlan: '暂无启动计划',
    noAllowlist: '暂无 MAC 白名单记录',
    noLogs: '暂无日志',
    discoveryResultId: '发现结果 ID',
    discoveryNicId: '发现网卡 ID',
    createAllowlist: '绑定 MAC 白名单',
    viewLogs: '查看日志',
    viewChecks: '查看检查',
    viewAllowlist: '查看白名单',
    name: '名称',
    family: '系统族',
    version: '版本',
    arch: '架构',
    bootMode: '启动模式',
    imageUrl: '镜像 URL',
    checksum: '校验值',
    storageBackend: '存储后端',
    pxeProfile: 'PXE Profile',
    osImage: 'OS 镜像',
    partitionStrategy: '分区策略',
    networkStrategy: '网络策略',
    installTemplate: '安装模板 JSON',
    postInstallScript: '安装后脚本',
    vlan: 'VLAN',
    cidr: 'CIDR',
    bindIp: 'Bind IP',
    gateway: '网关',
    dhcpRange: 'DHCP 范围',
    dnsServers: 'DNS',
    agentInterface: 'Agent / 网卡',
    targetMac: '目标 MAC',
    targetBmc: '目标 BMC IP',
    targetCount: '目标数',
    maxParallel: '并发数',
    macHash: 'MAC Hash',
    manifestHash: 'Manifest Hash',
    sourceRef: '来源编号',
    batchTargets: '批次目标',
    addTarget: '添加目标',
    batchSafetyNotice: '当前批量装机只创建 pending_approval 批次，不启用 DHCP/TFTP/iPXE，不触发 Agent active，不擦盘。',
    discoveryResult: '发现服务器',
    discoveryNic: '发现网卡',
    selectDiscoveryResult: '选择 Discovery 发现结果',
    selectDiscoveryNic: '选择 PXE 网卡',
    primaryNic: '主网卡',
    pxeEligible: 'PXE 可用',
    pxeNicOverride: '需确认',
    pxeNicOverrideReason: 'PXE 网卡选择原因',
    pxeNicOverrideRequired: '该网卡未被自动判定为 PXE 可用，请填写确认原因',
    pxeNicOverrideNotice: '当前选择的网卡未被自动判定为 PXE 可用。商业 IDC 场景允许人工确认，但会写入审计字段。',
    expires: '过期时间',
    phase: '阶段',
    message: '消息',
    payload: 'Payload',
    invalidJson: 'JSON 内容不合法',
    queued: '任务已排队',
    activeRejected: '真实 active 模式暂不开放，请使用 disabled 或 dry_run。',
    networkConfigNotice: '仅保存 Master 配置，不启动 DHCP/TFTP/iPXE，不修改交换机或远端服务器。',
    manifestHint: '日志 payload 中如出现 manifest_path 和 manifest_sha256，请使用 inspect-remote-pxe-manifest.ps1 做远程只读核验。',
  },
}

export const provisioningEnUS = {
  nav: { provisioning: 'Provisioning' },
  provisioning: {
    batchItems: 'Batch items',
    server: 'Server',
    title: 'Provisioning',
    description: 'Manage OS images, PXE profiles, provisioning networks, install tasks and safe dry-run results',
    safetyNotice: 'This phase only exposes dry-run and render verification. DHCP/TFTP/iPXE, service reloads and disk wipes remain disabled.',
    simpleWorkbenchKicker: 'INSTALL WORKBENCH',
    simpleWorkbenchTitle: 'Simple install workbench',
    simpleWorkbenchDescription: 'A simplified operations flow: confirm the server in inventory and verify MAC addresses, choose the OS and target NIC, then run dry-run / PXE render checks. Real DHCP/PXE execution remains disabled.',
    simpleStepInventory: 'Inventory check',
    simpleStepInventoryDesc: 'Confirm server SN, BMC, NIC MACs and rack placement.',
    simpleStepSelectOS: 'Select OS',
    simpleStepSelectOSDesc: 'Choose OS image, PXE profile and provisioning network.',
    simpleStepMacCheck: 'MAC compare',
    simpleStepMacCheckDesc: 'The target MAC must come from inventory/Discovery; mismatch blocks installation.',
    simpleStepDryRun: 'Safety check',
    simpleStepDryRunDesc: 'Generate manifest first and check Agent, VLAN, DHCP window and allowlist.',
    simpleCreateSingleInstall: 'Create single install task',
    simpleCreateBatchInstall: 'Create batch install plan',
    simpleNoRealExecution: 'Current UI does not start real DHCP/TFTP/iPXE, reboot servers, or wipe disks.',
    simpleReadyServers: 'Servers to confirm',
    simplePxeNics: 'PXE-ready NICs',
    simpleOnlineAgents: 'Online Agents',
    simpleImagesProfiles: 'Images / Profiles',
    simpleSafetyTitle: 'Install safety rules',
    simpleRuleMacMatch: 'Before installation, compare the target MAC again. Mismatch with inventory/Discovery terminates the task.',
    simpleRuleOneTimeBoot: 'For servers that do not boot from the install NIC by default, future real execution must set one-time PXE/NIC boot through BMC/IPMI before reboot.',
    simpleRuleFailStop: 'If installation fails, times out, or the Agent disconnects, terminate the task and avoid repeating risky actions.',
    simpleRuleTemporaryDHCP: 'DHCP/PXE may only be opened during the install window and must be closed with allowlist cleanup after success, failure, or timeout.',
    installSafetyStatusTitle: 'Install safety status',
    installSafetyStatusDescription: 'Operator-facing safety status: whether the system can really start DHCP/PXE, reboot servers, or run risky tasks.',
    installSafetyStatusMessage: 'Safety status is synced. Real install execution remains locked.',
    installSafetyLocked: 'Safely locked',
    installSafetyNeedsReview: 'Needs review',
    installSafetySynced: 'Status synced',
    installSafetyFallback: 'Status pending',
    plainMacCheck: 'MAC check',
    plainMacCheckDesc: 'Install tasks must use the target MAC from inventory/Discovery.',
    plainPxeExecution: 'Real PXE execution',
    plainPxeExecutionDesc: 'Starting real DHCP/TFTP/iPXE is not allowed at this stage.',
    plainDhcpWindow: 'Temporary DHCP/PXE',
    plainDhcpWindowDesc: 'Should stay closed when no controlled install window is active.',
    plainDangerTasks: 'Risky tasks',
    plainDangerTasksDesc: 'Number of real network apply, cleanup, or running risky execution tasks.',
    enabled: 'Enabled',
    disabled: 'Disabled',
    advancedDiagnostics: 'Show advanced diagnostics',
    advancedDiagnosticsDesc: 'Low-level safety counters for development and troubleshooting. Operators usually do not need these.',
    installableInventoryTitle: 'Installable inventory servers',
    installableInventoryDescription: 'A combined view from inventory/discovery results for checking SN, BMC, target MAC and Agent online status before installation.',
    servers: 'install targets',
    serverIdentity: 'Server',
    nicMac: 'NIC / MAC',
    macVerified: 'MAC verified',
    verified: 'Verified',
    pendingVerify: 'Pending',
    latestInstall: 'Latest install',
    installAllowed: 'Install allowed',
    startInstall: 'Start install',
    manualBootRequired: 'Manual boot check',
    yes: 'Yes',
    no: 'No',
    inventoryBlockedNoMac: 'Target MAC is missing',
    inventoryBlockedAgentOffline: 'Agent is offline',
    inventoryBlockedMissingConfig: 'OS image or PXE profile is missing',
    inventoryBootOverrideDefaultReason: 'This NIC is not marked as PXE-ready by default. Before future real execution, set one-time PXE/NIC boot through BMC/IPMI.',
    osImages: 'OS images',
    pxeProfiles: 'PXE profiles',
    networks: 'Provisioning networks',
    installBatches: 'Install batches',
    installTasks: 'Install tasks',
    logs: 'Install logs',
    checks: 'Network checks',
    allowlist: 'MAC allowlist',
    createImage: 'New image',
    createProfile: 'New profile',
    createNetwork: 'New network',
    configureNetwork: 'Configure network',
    createBatch: 'New install batch',
    createTask: 'New install task',
    dryRunNetwork: 'Network dry-run',
    installDryRun: 'Install dry-run',
    pxeRenderDryRun: 'PXE render dry-run',
    createBootPlan: 'Create boot plan',
    bootPlanLatest: 'Latest boot plan',
    bootPlanReadonlyNotice: 'Creates a one-time PXE boot plan only. It does not execute IPMI/Redfish or reboot the server.',
    bootPlanOneTimeBoot: 'One-time boot',
    bootPlanExecution: 'Real execution',
    bootPlanNoExecution: 'This is only a plan. No BMC command, reboot, DHCP, or PXE service was executed.',
    bootPlanReady: 'Boot plan ready',
    bootPlanCreated: 'Boot plan created; no real action executed',
    bootPlanTooltip: 'Create a BMC one-time PXE boot dry-run plan',
    bootPlanBlockedStatus: 'Only pre-execution install tasks can create boot plans',
    bootPlanBlockedNoNic: 'Discovery NIC is missing; MAC cannot be verified',
    bootPlanBlockedNoBmc: 'BMC IP is missing; boot plan cannot be created',
    installFlowTitle: 'Install flow overview',
    installFlowDescription: 'Shows each server in plain operations language: inventory, MAC check, boot plan, and real execution.',
    flowInventory: 'Inventory',
    flowInventoryDone: 'Inventory / Discovery linked',
    flowInventoryMissing: 'Inventory is missing',
    flowMacCheck: 'MAC check',
    flowMacDone: 'Target MAC is bound',
    flowMacMissing: 'Target MAC or NIC is missing',
    flowBootPlan: 'Boot plan',
    flowBootPlanDone: 'One-time PXE boot plan created',
    flowBootPlanReady: 'Ready to create a plan; no real action yet',
    flowRealInstall: 'Real install',
    flowRealInstallLocked: 'Locked; DHCP/PXE/IPMI not started',
    tasks: 'tasks',
    taskWizardSafetyNotice: 'This only creates an install task and MAC allowlist record. It does not start DHCP/TFTP/iPXE, reboot the server, or wipe disks.',
    taskWizardStepServer: 'Server / MAC',
    taskWizardStepOS: 'OS image',
    taskWizardStepConfirm: 'Confirm dry-run',
    taskWizardServerTitle: 'Step 1: Choose the server',
    taskWizardServerDesc: 'Choose the NIC from Inventory / Discovery. The UI fills MAC and BMC IP automatically. A MAC mismatch cannot continue.',
    taskWizardOSTitle: 'Step 2: Choose OS and install config',
    taskWizardOSDesc: 'Choose OS image, PXE profile, and provisioning network. This still only creates a task and does not start real PXE services.',
    taskWizardConfirmTitle: 'Step 3: Confirm and create task',
    taskWizardConfirmDesc: 'Confirm target MAC, BMC, OS image, and Agent. Saving moves the task into pending / dry-run workflow.',
    taskWizardConfirmSafety: 'Saving does not perform a real install. Boot plan and PXE dry-run checks are still required before any future real execution design.',
    taskWizardMissingRequired: 'Please complete the required fields in this step first',
    previousStep: 'Previous',
    nextStep: 'Next',
    batchDryRun: 'Batch dry-run',
    batchDryRunConfirm: 'Queue batch PXE render dry-run? This only generates a staging manifest and does not start DHCP/TFTP/iPXE or wipe disks.',
    viewBatchDetail: 'View details',
    batchDetail: 'Batch detail',
    batchSummary: 'Batch summary',
    batchDetailReadonlyNotice: 'Read-only audit view. This page does not start DHCP/TFTP/iPXE and does not wipe disks.',
    latestDryRun: 'Latest dry-run',
    agentTaskId: 'Agent task ID',
    manifestPath: 'Manifest path',
    renderedFileCount: 'Rendered files',
    renderedFiles: 'Rendered files',
    safetyFlags: 'Safety flags',
    noLatestDryRun: 'This batch has no linked Agent dry-run result yet.',
    activationPreflight: 'Activation preflight',
    activationPreflightNotice: 'Checks gate conditions only; does not start DHCP/TFTP/iPXE.',
    activationPreflightPassed: 'Activation preflight passed',
    activationPreflightFailed: 'Activation preflight failed',
    activationPreflightMissingHash: 'Manifest hash is missing; cannot run preflight',
    hostBindPreflight: 'Host bind preflight',
    hostBindPreflightNotice: 'Checks Agent interface, VLAN, bind_ip and lease conditions only; it does not change host networking or start DHCP/TFTP/iPXE.',
    hostBindPreflightSummary: 'Host bind preflight summary',
    hostBindPreflightPassed: 'Host bind preflight passed',
    hostBindPreflightFailed: 'Host bind preflight failed',
    createHostBindDryRunLease: 'Create dry-run lease',
    hostBindDryRunLease: 'Host bind dry-run lease',
    hostBindDryRunLeaseNotice: 'Creates an audit/coordination lease only. It does not create Agent tasks, change NICs, or start DHCP/TFTP/iPXE.',
    hostBindDryRunLeaseConfirm: 'Create a Host Bind dry-run lease? This only writes an audit lease and will not create Agent tasks, modify remote NICs, or start DHCP/TFTP/iPXE.',
    hostBindDryRunLeaseCreated: 'Host bind dry-run lease created',
    hostBindLeases: 'Host bind leases',
    hostBindLeaseReadonlyNotice: 'Read-only history view. No apply or cleanup actions are exposed.',
    hostBindGuardTitle: 'Host bind safety guard',
    hostBindGuardDescription: 'Contract-only / locked: Master and UI do not expose apply/cleanup. No Agent task, no NIC change, no DHCP/TFTP/iPXE.',
    contractOnlyLocked: 'CONTRACT-ONLY LOCKED',
    visibleActiveBindLeases: 'Visible active leases',
    visibleApplyCleanupTaskRefs: 'Visible apply/cleanup task refs',
    backendAuthoritative: 'Backend authoritative',
    visibleFallback: 'Visible fallback',
    guardStatusLoadFailed: 'Guard status load failed',
    authoritativeActiveBindLeases: 'DB active bind leases',
    authoritativeDryRunBindLeases: 'DB dry-run bind leases',
    authoritativeApplyCleanupTaskRefs: 'DB apply/cleanup task refs',
    authoritativeApplyCleanupAgentTasks: 'DB apply/cleanup AgentTasks',
    pendingRunningApplyCleanupTasks: 'Pending / Running apply-cleanup tasks',
    applyCleanupApiLocked: 'Apply/Cleanup API locked',
    agentTaskCreationEnabled: 'AgentTask creation enabled',
    uiApplyCleanupActions: 'UI apply/cleanup actions',
    supportedBindMethods: 'Supported bind methods',
    applyCleanupTaskTypes: 'Apply/Cleanup task types',
    applyCleanupTaskRefs: 'Apply/Cleanup task refs',
    notExposed: 'Not exposed',
    reviewRequired: 'Review required',
    none: 'None',
    leaseNetworkFilter: 'Filter by provisioning network',
    leaseStatusFilter: 'Filter by lease status',
    leaseActivity: 'Lease activity',
    activeLease: 'Active',
    inactiveLease: 'Inactive/expired',
    applyStrategy: 'Apply strategy',
    preflightCheckCount: 'Preflight checks',
    activationLocked: 'Activation locked',
    bindApplyEnabled: 'Bind apply enabled',
    bindMethod: 'Bind method',
    check: 'Check',
    installTaskId: 'Install task ID',
    operatorTaskListTitle: 'Install task list',
    operatorTaskListDesc: 'Server-first view: target server, MAC, OS, status and logs. Internal IDs are collapsed until troubleshooting.',
    taskTotal: 'Total',
    taskActive: 'Active',
    taskSucceeded: 'Succeeded',
    taskFailed: 'Failed',
    taskTechnicalDetail: 'Technical details',
    unknownServer: 'Unlinked inventory server',
    switchPortUnknown: 'Switch port not recorded',
    osAndTemplate: 'OS / Template',
    createdAt: 'Created at',
    errorMessage: 'Error message',
    deviceId: 'Device ID',
    taskFocusTitle: 'Focused on this server install task',
    taskFocusDesc: 'Only install tasks related to the server opened from inventory are shown.',
    showAllTasks: 'Show all tasks',
    taskDetail: 'Install task detail',
    taskDetailReadonlyNotice: 'Centralized read-only view for install data, allowlist, boot plan and logs. It does not start DHCP/PXE/IPMI, reboot, or wipe disks.',
    taskDetailServer: 'Target server',
    taskDetailInstallInfo: 'Install info',
    taskDetailNetworkInfo: 'Network info',
    taskDetailFlow: 'Task flow',
    taskDetailBootPlan: 'Boot plan',
    taskDetailIds: 'Linked IDs',
    switchPort: 'Switch port',
    noBootPlan: 'No boot plan yet',
    noAllowlist: 'No MAC allowlist records',
    noLogs: 'No logs yet',
    discoveryResultId: 'Discovery result ID',
    discoveryNicId: 'Discovery NIC ID',
    createAllowlist: 'Bind MAC allowlist',
    viewLogs: 'View logs',
    viewChecks: 'View checks',
    viewAllowlist: 'View allowlist',
    name: 'Name',
    family: 'Family',
    version: 'Version',
    arch: 'Architecture',
    bootMode: 'Boot mode',
    imageUrl: 'Image URL',
    checksum: 'Checksum',
    storageBackend: 'Storage backend',
    pxeProfile: 'PXE profile',
    osImage: 'OS image',
    partitionStrategy: 'Partition strategy',
    networkStrategy: 'Network strategy',
    installTemplate: 'Install template JSON',
    postInstallScript: 'Post-install script',
    vlan: 'VLAN',
    cidr: 'CIDR',
    bindIp: 'Bind IP',
    gateway: 'Gateway',
    dhcpRange: 'DHCP range',
    dnsServers: 'DNS',
    agentInterface: 'Agent / interface',
    targetMac: 'Target MAC',
    targetBmc: 'Target BMC IP',
    targetCount: 'Targets',
    maxParallel: 'Max parallel',
    macHash: 'MAC hash',
    manifestHash: 'Manifest hash',
    sourceRef: 'Source ref',
    batchTargets: 'Batch targets',
    addTarget: 'Add target',
    batchSafetyNotice: 'Batch install currently only creates pending_approval batches. DHCP/TFTP/iPXE, Agent active mode, and disk wipe remain disabled.',
    discoveryResult: 'Discovered server',
    discoveryNic: 'Discovered NIC',
    selectDiscoveryResult: 'Select a Discovery result',
    selectDiscoveryNic: 'Select PXE NIC',
    primaryNic: 'Primary NIC',
    pxeEligible: 'PXE eligible',
    pxeNicOverride: 'Needs confirmation',
    pxeNicOverrideReason: 'PXE NIC selection reason',
    pxeNicOverrideRequired: 'This NIC is not marked PXE eligible. Please enter a confirmation reason.',
    pxeNicOverrideNotice: 'The selected NIC is not marked PXE eligible. Manual confirmation is allowed for IDC operations and will be audited.',
    expires: 'Expires at',
    phase: 'Phase',
    message: 'Message',
    payload: 'Payload',
    invalidJson: 'JSON content is invalid',
    queued: 'Task queued',
    activeRejected: 'Real active mode is not exposed yet. Use disabled or dry_run.',
    networkConfigNotice: 'Saves Master configuration only. It does not start DHCP/TFTP/iPXE and does not change switches or remote servers.',
    manifestHint: 'When logs include manifest_path and manifest_sha256, verify them with inspect-remote-pxe-manifest.ps1.',
  },
}
